import React, { forwardRef, type ReactNode } from 'react'
import { scrollableContainer, scrollableItem } from './ScrollRow.css'

type Alignment = 'left' | 'center' | 'right'

export type ScrollRowProps = {
  children: ReactNode
  alignment?: Alignment
}

export const ScrollRow = forwardRef<HTMLDivElement, ScrollRowProps>(({ children, alignment = 'left' }, ref) => {
  return (
    <div ref={ref} className={scrollableContainer} data-alignment={alignment}>
      {/* We need to wrap each children for scroll snapping to work. */}
      {/* React.Children helps us with single/multiple children scenarios. */}
      {/* It also handles null/undefined children and fragments automatically. */}
      {React.Children.map(children, (child, index) => (
        <div key={index} className={scrollableItem}>
          {child}
        </div>
      ))}
    </div>
  )
})
ScrollRow.displayName = 'ScrollRow'
